export const marketingIt = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Quickstart gratuito',
  'marketing.free.seo.description':
    'Scarica il Quickstart di Grymwyrd gratis — le regole e un\'avventura autunnale che puoi giocare stasera. Entra nel Crepuscolo.',
  'marketing.free.eyebrow': 'Il tuo accesso gratuito',
  'marketing.free.heading': 'Entra nel Crepuscolo — gratuitamente',
  'marketing.free.subheadLead': 'Il',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— le regole essenziali più un\'avventura horror a sessione unica che puoi giocare stasera. Dicci dove inviartela.',
  'marketing.free.benefit.rules.title': 'Le regole',
  'marketing.free.benefit.rules.body': 'Tutto quello che ti serve per giocare, distillato in un quickstart.',
  'marketing.free.benefit.oneShot.title': 'Un\'avventura unica',
  'marketing.free.benefit.oneShot.body': 'Un\'avventura horror pronta per il tuo primo turno di gioco.',
  'marketing.free.benefit.livingWorld.title': 'Mondo vivente',
  'marketing.free.benefit.livingWorld.body': 'Collegamenti con un\'enciclopedia, mappe e aggiornamenti settimanali.',
  'marketing.free.playInstead.heading': 'Preferisci giocare subito?',
  'marketing.free.playInstead.body':
    'Forgia il tuo primo personaggio e affronta una prova di 10 minuti in solitaria — nessun acquisto, nessun vincolo.',
  'marketing.free.playInstead.cta': 'Forgia un personaggio',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Qualcosa è andato storto. Riprova fra poco.',
  'marketing.leadForm.ready': 'Il tuo Quickstart gratuito è pronto.',
  'marketing.leadForm.downloadCta': 'Scarica il tuo Quickstart',
  'marketing.leadForm.alsoEmailed': 'Abbiamo inviato il link anche alla tua casella di posta.',
  'marketing.leadForm.checkInbox': 'Controlla la tua casella di posta — il tuo Quickstart gratuito è in arrivo.',
  'marketing.leadForm.emailPlaceholder': 'tu@esempio.com',
  'marketing.leadForm.emailAriaLabel': 'Indirizzo email',
  'marketing.leadForm.defaultCta': 'Mandami lo Quickstart',
  'marketing.leadForm.privacyNote':
    'Nessuno spam — solo lo Quickstart e qualche goccia di lore occasionale. Puoi disiscriverti in qualsiasi momento.',
} as const
